import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthStorageService, BaseSiteService, UserIdService } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MyaccountCredentialsService {
  tokenId: any;
  baseSite$: Observable<string> = this.baseService.getActive();
  userCurrent$: Observable<string> = this.auth.getUserId();
  baseSiteId: any;
  isYourCredentialsDetailsLoaded = new BehaviorSubject<boolean>(false);

  constructor(
    protected http: HttpClient,
    protected auth: UserIdService,
    protected authStorageService: AuthStorageService,
    protected baseService: BaseSiteService,
    private meta: Meta
  ) {}

  get userCurrent(): string {
    let userCurrent = '';
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  getYourCredentials() {
    this.isYourCredentialsDetailsLoaded.next(false);
    const occURL = this.meta.getTag('name=occ-backend-base-url');
    this.authStorageService
      .getToken()
      .pipe(map((data) => data.access_token))
      .subscribe((results: any) => {
        this.tokenId = results;
      });

    this.baseSite$.pipe(take(1)).subscribe((data) => {
      this.baseSiteId = data;
    });

    return this.http
      .get(`${occURL?.content}${environment.prefix}${this.baseSiteId}/users/${this.userCurrent}`, {})
      .pipe(map((data) => data));
  }
}
